import styled from "styled-components";

export const TabsBigContainer = styled.div`
  padding: 1rem;
  position: relative;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: flex-end;
  padding-left: 2px;
  position: relative;
  z-index: 2;
`;

export const TabsContainer = styled.div`
  background: ${(props) => props.theme.MSBackground};
  border: none;
  box-shadow: ${(props) => props.theme.standardBoxShadow};
  position: relative;
  z-index: 1;
  margin-top: -2px;
`;

// Selected tab is taller and overlaps the panel border so it looks attached
export const TabContainer = styled.div<{ $selected: boolean }>`
  background: ${(props) => props.theme.MSBackground};
  box-shadow: ${(props) => props.theme.standardBoxShadowNoBottom};
  border-radius: 3px 3px 0 0;
  padding: ${(props) => (props.$selected ? "5px 12px 7px" : "3px 10px 3px")};
  margin: ${(props) => (props.$selected ? "0 -2px" : "0 0 2px")};
  position: relative;
  z-index: ${(props) => (props.$selected ? 3 : 1)};
  font-size: ${(props) => props.theme.fontNormal}px;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
`;
